import React from "react";
import {SelectField} from "./FilterComponentStyles";
import {
    DEDICATED_HIDDEN_SHIFT_STATUSES,
    REPORT_ONLY_SHIFT_STATUSES,
    SHIFT_STATUS_ORDER
} from "../../../constants/shiftStatuses";

const PoolShiftStatusFilter = ({
    value,
    onChange,
    excludeReportStatuses = false,
    excludeDedicatedHiddenStatuses = false
}) => {
    const hiddenStatuses = [
        ...(excludeReportStatuses ? REPORT_ONLY_SHIFT_STATUSES : []),
        ...(excludeDedicatedHiddenStatuses ? DEDICATED_HIDDEN_SHIFT_STATUSES : [])
    ];
    const statuses = SHIFT_STATUS_ORDER.filter(status => !hiddenStatuses.includes(status));

    return (
        <React.Fragment>
            <h5>{"Durum"}</h5>
            <SelectField value={value} data-testid="pool_shift_status" onChange={onChange}>
                <SelectField.Option data-testid="status_option" value={"all"}>
                    {"Tümü"}
                </SelectField.Option>
                {statuses.map(status => (
                    <SelectField.Option data-testid="status_option" key={status} value={status}>
                        {status}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default PoolShiftStatusFilter;
